const info2 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.25 2.95h1.5v1.5h-1.5zm0 3.1h1.5v7h-1.5z"/></svg>',
};

export { info2 as default };
